import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative w-full overflow-hidden bg-white px-4 py-8 md:py-20 lg:px-8" data-id="element-94">
      <div className="mx-auto max-w-7xl" data-id="element-95">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-12 lg:items-center" data-id="element-96">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col space-y-6" data-id="element-97">
            <h1 className="font-serif text-3xl font-bold leading-tight text-terracotta md:text-4xl lg:text-5xl text-center lg:text-left" style={{
            fontSize: '28px'
          }} data-id="element-98">
              Se rieron de mí cuando dije que no volvería a picar cebolla un
              martes... pero se quedaron mudos cuando probaron mi cena lista en
              10 minutos.
            </h1>

            {/* Drama Image */}
            <div className="mx-auto w-full lg:mx-0" data-id="element-99">
              <img src="https://cdn.magicpatterns.com/uploads/7GZx8neF1nThbTaSrY6grb/imagen_drama.png" alt="Mamá agotada en la cocina" className="w-full rounded-2xl shadow-xl" data-id="element-100" />
            </div>

            <div className="space-y-6 text-center lg:text-left" data-id="element-101">
              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl" style={{
              fontWeight: '400'
            }} data-id="element-102">
                "Eran las 6:14 PM, cuando tiré la sartén contra la pared. El
                estruendo del metal fue lo único que logró silenciar, por un
                segundo, el caos de mi cabeza. Recuerdo el olor a quemado del
                sartén porque me distraje un segundo tratando de que mi hijo
                dejara de llorar por unos nuggets congelados. Tenía el cabello
                pegajoso por el vapor, los pies me pulsaban de estar parada todo
                el día y, lo peor de todo, sentía una culpa asfixiante.
              </p>

              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl" data-id="element-103">
                Ahí estaba yo, con la nevera llena de comida que se iba a pudrir
                porque no tenía la energía para picar una sola cebolla más. Mi
                esposo entró por la puerta, me miró y me preguntó lo que yo más
                temía: '¿Qué hay de cenar?'.
              </p>

              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl" data-id="element-104">
                Algo dentro de mí se rompió definitivamente. Dejé caer la
                espátula al fregadero, me senté en el suelo entre platos sucios
                y simplemente me eché a llorar. Me sentía prisionera en mi
                propia casa. Estaba sacrificando mi paz mental, mi salud y el
                tiempo con mis hijos por la tiranía de tener que cocinar
                'fresco' desde cero cada maldita noche.
              </p>

              {/* Pizza drama image */}
              <div className="mx-auto w-full lg:mx-0" data-id="element-105">
                <img src="https://cdn.magicpatterns.com/uploads/7QoPBw3kASNmvgt4334Ttz/imagen_drama_2.png" alt="Pareja comiendo pizza mediocre en el sofá" className="w-full rounded-2xl shadow-xl" data-id="element-106" />
              </div>

              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl" data-id="element-107">
                Esa noche, mientras masticábamos una pizza mediocre de 30
                dólares que nos dejó sintiéndonos pesados y culpables, me hice
                una promesa: Tenía que haber otra forma.
              </p>

              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl" data-id="element-108">
                No podía ser que la única opción fuera ser una esclava de la
                estufa o alimentar a mi familia con basura procesada. Comencé a
                investigar lo que nadie te dice en los tutoriales de cocina.
                Descubrí que el verdadero problema no era que yo fuera
                desorganizada o que no tuviera 'ideas'. El problema es que el
                sistema tradicional de cocina está diseñado para un mundo que ya
                no existe.
              </p>

              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl" data-id="element-109">
                Fue entonces cuando, tras meses de pruebas, errores y mucha
                comida desperdiciada, encontré un método sencillo para recuperar
                mi vida. No se trata de pasos de procesos complejos. Es una
                forma de lógica distinta en la cocina; una manera de preparar
                todo una sola vez que me devolvió la libertad.
              </p>

              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl" data-id="element-110">
                La primera vez que lo logré, me senté en el sofá a las 6:00 PM
                con una copa de vino, mientras escuchaba a mis hijos jugar en la
                sala. La cena estaba lista, olía delicioso y se sentía tan
                fresca como si la acabara de comprar... y yo no había tocado un
                cuchillo en todo el día.
              </p>

              <p className="text-lg leading-relaxed text-text-dark/90 md:text-xl font-medium italic" data-id="element-111">
                En ese instante supe que tenía que entregarle esta llave de
                libertad a cada mujer que hoy se siente atrapada, tal como yo me
                sentía aquel martes."
              </p>

              {/* Product 4 Seasons Image */}
              <div className="mx-auto w-full lg:mx-0" data-id="element-112">
                <img src="https://cdn.magicpatterns.com/uploads/vo4UKLmoaSegBMWY4eDR4L/1.png" alt="Las 4 Guías de Temporada" className="w-full rounded-2xl shadow-xl" data-id="element-113" />
              </div>
            </div>

            <div className="flex flex-col items-center space-y-4 pt-4 lg:items-start" data-id="element-114">
              <div className="flex items-baseline space-x-3" data-id="element-115">
                <span className="text-2xl text-gray-400 line-through decoration-red-400 decoration-2" data-id="element-116">
                  $37
                </span>
                <span className="text-4xl font-bold text-terracotta" data-id="element-117">
                  $9.98
                </span>
              </div>

              <a href="#mid-pricing" onClick={e => {
              e.preventDefault();
              document.getElementById('mid-pricing')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="group inline-flex items-center justify-center rounded-full bg-terracotta px-8 py-4 text-lg font-bold text-white shadow-lg transition-all hover:bg-[#d6761b] hover:shadow-xl hover:-translate-y-0.5" data-id="element-118">
                Compra el Protocolo de Cenas de Paz por $9.98
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-119" />
              </a>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-120">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl ring-4 ring-gray-100" data-id="element-121"></div>
            {/* Decorative element - updated colors */}
            <div className="absolute -bottom-6 -right-6 -z-10 h-64 w-64 rounded-full bg-sage/10 blur-3xl" data-id="element-122"></div>
            <div className="absolute -top-6 -left-6 -z-10 h-64 w-64 rounded-full bg-terracotta/5 blur-3xl" data-id="element-123"></div>
          </motion.div>
        </div>
      </div>
    </section>;
};